import { atom } from 'recoil';

import { IAlert } from './types';

export const alertsState = atom<IAlert[]>({
  key: 'alertsState',
  default: [],
});

export const systemFolderIdState = atom<string | undefined>({
  key: 'systemFolderIdState',
  default: undefined,
});

export const selectedFolderIdState = atom<string | undefined>({
  key: 'selectedFolderState',
  default: undefined,
});
